import React from "react";

const StartButton = ({text, onClick}) => {
  const buttonBaseStyle = {
    padding: "14px 32px",
    backgroundColor: "orange", // Bright orange for motivation
    color: "#fff",
    border: "none",
    borderRadius: "25px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
    animation: "pulse 1.8s infinite", // Pulse animation
  };

  const hoverStyle = {
    backgroundColor: "#EF7722",
    transform: "scale(1.08)",
    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.3)",
  };

  const [isHovered, setIsHovered] = React.useState(false);

  // Inject pulse animation dynamically once (for safety)
  React.useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 102, 0, 0.6); }
        70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(255, 102, 0, 0); }
        100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255, 102, 0, 0); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <button
      style={{
        ...buttonBaseStyle,
        ...(isHovered ? hoverStyle : {}),
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default StartButton;
